import React, { useEffect, useState } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';

import { LOGOUT } from 'ConstComponents';
import { AgentActivate as AEPS_AGENTACTIVATION } from 'Components/Api/EkoAEPSAPI';
import { FetchDetailsForPincode as FETCH_DETAILS_FOR_PINCODE } from 'Components/Api/UsersApi';

import SearchIcon from 'Components/SvgButtons/SearchIcon';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import {
    Container,
    Grid,
    Paper,
    Button,
    CircularProgress,
    Box,
    TextField
} from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    PLEASE_SELECT_VALID,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';

import HOCLoader from 'Components/Loader/HOCLoader';

import { FailTransactionResponse } from 'Components/Alert/FailTransactionResponse';
const CustomContainer = HOCLoader(Container);

export const EkoAgentActivation = () => {
    const classes = commonStyle();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [DisplayImage, setDisplayImage] = useState(false);
    const [PanCardImage, setPanCardImage] = useState('');
    const [AadharFrontImage, setAadharFrontImage] = useState('');
    const [AadharBackImage, setAadharBackImage] = useState('');
    const [status, setStatus] = useState('PROCESS');
    const [Message, setMessage] = useState('');

    const [isAlertErrorOpen, setIsAlertErrorOpen] = useState(false);
    const [UserObj, setUserObj] = useState({
        City: '',
        Devicenumber: '',
        Modelname: '',
        State: '',
        Address: '',
        PinCode: '',
        PanCard: {
            Name: '',
            Size: '',
            Type: '',
            Data: ''
        },
        AadharFront: {
            Name: '',
            Size: '',
            Type: '',
            Data: ''
        },
        AadharBack: {
            Name: '',
            Size: '',
            Type: '',
            Data: ''
        }
    });

    const FetchDetails = async (formProps) => {
        var request = {
            PinCode: formProps.values.PinCode
        };
        var requestObj = JSON.stringify(request);

        setLoading(true);
        setIsError(false);

        var response = await FETCH_DETAILS_FOR_PINCODE(requestObj);

        if (!response.isAuthorized) LOGOUT();

        setLoading(false);
        setIsError(true);
        setSeverity('success');

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);

            setStatus('FAILURE');
            setMessage(response.data);
            setIsAlertErrorOpen(true);
            return;
        }

        var data = JSON.parse(response.data);

        formProps.setFieldValue('State', data.State);
        formProps.setFieldValue('Address', data.CityName);
        formProps.setFieldValue('City', data.District);
    };

    useEffect(() => {}, []);

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        setLoading(true);
        setIsError(false);
        setResponseMessage('');

        var inputObj = {
            City: values.City,
            Devicenumber: values.Devicenumber,
            Modelname: values.Modelname,
            State: values.State,
            Address: values.Address,
            PinCode: values.PinCode,
            PanCard: values.PanCard,
            AadharFront: values.AadharFront,
            AadharBack: values.AadharBack
        };

        const { isAuthorized, status, data } = await AEPS_AGENTACTIVATION(
            JSON.stringify(inputObj)
        );
        setLoading(false);
        if (!isAuthorized) LOGOUT();

        if (!status) {
            setSeverity('error');
            setResponseMessage(data);
            setIsError(true);

            setStatus('FAILURE');
            setMessage(data);
            setIsAlertErrorOpen(true);
            return;
        }

        var dataInner = JSON.parse(data);
        setSeverity('success');
        setResponseMessage(dataInner.Message);
        setIsError(true);

        setSubmitting(false);

        resetForm(UserObj);

        history.push('/EAEPS');
    };

    const validationSchema = Yup.object({
        City: Yup.string()
            .trim()
            .required(PLEASE_PROVIDE_VALID + 'City'),

        PinCode: Yup.string()
            .trim()
            .required(PLEASE_PROVIDE_VALID + 'PinCode'),

        Devicenumber: Yup.string()
            .trim()
            .required(PLEASE_PROVIDE_VALID + 'Devicenumber'),

        Modelname: Yup.string().required(PLEASE_SELECT_VALID + 'Modelname')
    });

    const UploadForm = (formProps) => {
        return (
            <Form>
                <Paper style={{ padding: 8 }} className={classes.PaperStyle}>
                    <label>
                        <h3 className={classes.Provider_Format}>
                            The file size for the documents for AePS activation
                            should be less than 1MB <br></br>
                            We accept the images in JPEG, JPG and PDF format,
                            not in PNG. PNG images are rejected from the partner
                            bank
                        </h3>
                    </label>
                    <h2 className={classes.PaperHead_h2}>
                        Device Detalis
                        <span className={classes.Require}>*</span>
                    </h2>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <MaterialTextField
                                    label="Devicenumber"
                                    name="Devicenumber"
                                    type="text"
                                    title="Devicenumber"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <MaterialTextField
                                    label="Modelname"
                                    name="Modelname"
                                    type="text"
                                    title="Modelname"
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <h2 className={classes.PaperHead_h2}>
                        Address
                        <span className={classes.Require}>*</span>
                    </h2>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialTextField
                                    label="Address"
                                    name="Address"
                                    type="text"
                                    title="Address"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialTextField
                                    label="City"
                                    name="City"
                                    type="text"
                                    icon="shop"
                                    title="City"
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialTextField
                                    label="State"
                                    name="State"
                                    type="text"
                                    length={20}
                                    title="State"
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <MaterialNumberField
                                    label="Pin code"
                                    name="PinCode"
                                    type="text"
                                    length={6}
                                    title="Pin code"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={1} lg={1}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    endIcon={<SearchIcon />}
                                    className={classes.CustomPrimaryButtonStyle}
                                    onClick={() => {
                                        FetchDetails(formProps);
                                    }}
                                    style={{ marginLeft: '10px' }}
                                ></Button>
                            </Grid>
                        </Grid>
                    </Grid>

                    <h2 className={classes.PaperHead_h2}>
                        KYC Details
                        <span className={classes.Require}>*</span>
                    </h2>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <label style={{ margin: '10px' }}>
                                    Pan Card Image
                                </label>
                                <TextField
                                    id="file"
                                    name="PanCard"
                                    type="file"
                                    accept=".jpg, .jpeg"
                                    onChange={(e) => {
                                        var file = e.target.files[0];

                                        setPanCardImage(
                                            URL.createObjectURL(file)
                                        );

                                        var reader = new FileReader();
                                        formProps.setFieldValue(
                                            'PanCard.Name',
                                            file.name
                                        );
                                        formProps.setFieldValue(
                                            'PanCard.Size',
                                            file.size
                                        );
                                        formProps.setFieldValue(
                                            'PanCard.Type',
                                            file.type
                                        );
                                        reader.onload = function (item) {
                                            formProps.setFieldValue(
                                                'PanCard.Data',
                                                item.target.result
                                                    .replace('data:', '')
                                                    .replace(/^.+,/, '')
                                            );
                                        };

                                        reader.readAsDataURL(file);
                                        setDisplayImage(true);
                                    }}
                                />
                            </Grid>
                            {DisplayImage ? (
                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                    <img
                                        name="PanCardImage"
                                        src={PanCardImage}
                                        height={100}
                                        width={300}
                                        alt={PanCardImage}
                                    />
                                </Grid>
                            ) : null}

                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <label style={{ margin: '10px' }}>
                                    Aadhar Front Image
                                </label>
                                <TextField
                                    id="file"
                                    name="AadharFront"
                                    type="file"
                                    accept=".jpg, .jpeg"
                                    onChange={(e) => {
                                        var file = e.target.files[0];

                                        setAadharFrontImage(
                                            URL.createObjectURL(file)
                                        );

                                        var reader = new FileReader();
                                        formProps.setFieldValue(
                                            'AadharFront.Name',
                                            file.name
                                        );
                                        formProps.setFieldValue(
                                            'AadharFront.Size',
                                            file.size
                                        );
                                        formProps.setFieldValue(
                                            'AadharFront.Type',
                                            file.type
                                        );
                                        reader.onload = function (item) {
                                            formProps.setFieldValue(
                                                'AadharFront.Data',
                                                item.target.result
                                                    .replace('data:', '')
                                                    .replace(/^.+,/, '')
                                            );
                                        };

                                        reader.readAsDataURL(file);
                                        setDisplayImage(true);
                                    }}
                                />
                            </Grid>
                            {DisplayImage ? (
                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                    <img
                                        name="AadharFrontImage"
                                        src={AadharFrontImage}
                                        height={100}
                                        width={300}
                                        alt={AadharFrontImage}
                                    />
                                </Grid>
                            ) : null}

                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <label style={{ margin: '10px' }}>
                                    Aadhar Back Image
                                </label>
                                <TextField
                                    id="file"
                                    name="AadharBack"
                                    type="file"
                                    accept=".jpg, .jpeg"
                                    onChange={(e) => {
                                        var file = e.target.files[0];

                                        setAadharBackImage(
                                            URL.createObjectURL(file)
                                        );

                                        var reader = new FileReader();
                                        formProps.setFieldValue(
                                            'AadharBack.Name',
                                            file.name
                                        );
                                        formProps.setFieldValue(
                                            'AadharBack.Size',
                                            file.size
                                        );
                                        formProps.setFieldValue(
                                            'AadharBack.Type',
                                            file.type
                                        );
                                        reader.onload = function (item) {
                                            formProps.setFieldValue(
                                                'AadharBack.Data',
                                                item.target.result
                                                    .replace('data:', '')
                                                    .replace(/^.+,/, '')
                                            );
                                        };

                                        reader.readAsDataURL(file);
                                        setDisplayImage(true);
                                    }}
                                />
                            </Grid>
                            {DisplayImage ? (
                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                    <img
                                        name="AadharBackImage"
                                        src={AadharBackImage}
                                        height={100}
                                        width={300}
                                        alt={AadharBackImage}
                                    />
                                </Grid>
                            ) : null}
                        </Grid>
                    </Grid>
                </Paper>

                <Grid className={classes.footerGrid}>
                    <Box className={classes.flexReverse}>
                        <div className={classes.SubmitWrapper}>
                            <Button
                                type="submit"
                                title="Agent Activate"
                                className={classes.CustomPrimaryButtonStyle}
                                disabled={loading}
                            >
                                Agent Activate
                            </Button>
                            {loading && (
                                <CircularProgress
                                    size={24}
                                    className={classes.buttonProgress}
                                />
                            )}
                        </div>
                        <Button
                            type="reset"
                            title="Reset"
                            className={classes.CustomDangerButtonStyle}
                        >
                            Reset
                        </Button>
                    </Box>
                </Grid>
            </Form>
        );
    };
    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={UserObj}
                validationSchema={validationSchema}
                onSubmit={submithandle}
                resetForm={UserObj}
            >
                {UploadForm}
            </Formik>

            {isAlertErrorOpen ? (
                <FailTransactionResponse
                    isOpen={isAlertErrorOpen}
                    title={status}
                    Message={Message}
                    OkButtonClick={(request) => {
                        setIsAlertErrorOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
